<template>
  <div>
    <div class="myspinner">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <form @submit.prevent="showOTP ? submitFinal() : onsubmit()">
      <va-input
        v-focus
        v-if="!showOTP"
        v-model="email"
        type="text"
        :label="$t('auth.email-or-phone')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />

      <va-input
        v-if="!showOTP"
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />

      <va-input
        v-if="showOTP"
        v-model="otp"
        type="text"
        :label="$t('auth.otp')"
        :error="!!otpErrors.length"
        :error-messages="otpErrors"
      />

      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0" :disabled="disableButton">{{ $t('auth.login') }}</va-button>
      </div>
    </form>
    <br>
   <!--  <div class="auth-layout__options d-flex align--center">
        Useful Links:<a href="https://www.kenversitysacco.co.ke" class="link" target="_blank"> Kenversity Website </a>   &nbsp;| &nbsp;<a href="https://kenversitysacco.co.ke/downloads.php" class="link" target="_blank"> Downloads </a> &nbsp; | &nbsp;<a href="https://play.google.com/store/apps/details?id=com.cft.kenversitysaccobanking" class="link" target="_blank">&nbsp;App<img src="../../../assets/imgs/play.png"  width="10%" height="10%"></a>     
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'login',
  data () {
    return {
      loading:false,
      disableButton:false,
      showOTP:false,
      retries:4,
      conn:false,
      otp:'',
      email: '',
      password: '',
      user_id:'',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
      errors: [],
      otpErrors: [],
      otp_no:'',
      token:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: "#e60000",
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length && !this.otpErrors.length
    },
  },
  methods: {
    checkConenction () {
      const self = this
      axios.get(`${this.$apiUrl}pingAddress`)
      .then(function (res) { 
        var response = res.data
        if(response.success == 0){
          self.showToast(`Could not establish a connection to your sacco please try again later`, {
            position: 'bottom-right',
            icon: "fa-times",
            duration: 10000,
          })
          self.conn = false;
        }else{
         self.conn = true;
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']

      const data = {
        email: this.email,
        password: this.password,
        company_id: 287,
      }

      const formdata = {
        data: data,
        readotp:{
          "otp" : "true",
          "is_portal" : "true"
        },
      }

      console.log(this.conn);

      if (this.formReady && this.conn) {
        this.disableButton = true;
        this.loading = true;
       
        localStorage.removeItem('LoggedUser')
        localStorage.removeItem('UserMianFosa') 
        localStorage.removeItem('UserFosas') 
        var self = this      
        axios.post(`${this.$apiUrl}AuthSaccoUser`, formdata)
        .then(function (res) {
          self.disableButton = false;
          const response = res.data
          console.log(response);
          self.loading = false;
          if (response.success === 0) {
            self.emailErrors = ['Invalid Email/Phone No. or Password']
            self.passwordErrors = ['Invalid Email/Phone No. or Password']
          } else {
            self.retries = 4;                  
            self.user_id = response.userData;
            self.otp_no = response.otp;
            self.showOTP = true;            
            self.otpErrors = ['Input OTP']
            self.showToast(`Successful! An OTP has been send to your Phone NO. Please input 4 digit OTP to Login`, {
              position: 'bottom-right',
              icon: "fa-check",
              duration: 10000,
            })
            setTimeout( () => self.showOTP = false, 300000);
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    login () {
      this.$router.push({ name: 'dashboard' })      
    },

    submitFinal(){
      this.otpErrors = this.otp ? [] : ['OTP field field is required']
      const dat = {
          "otp" : this.otp,
          "user" : this.user_id
      };
      
      let config = {
        headers: {
          Authorization: this.user_id+' '+this.token //the token is a variable which holds the token
        }
      }

      if (this.formReady && this.retries >= 1) {
        this.retries = this.retries - 1;
        this.loading = true;       
        var self = this      
        axios.post(`${this.$apiUrl}checkotpStatus`, dat, config)
        .then(function (res) {
          self.disableButton = false;
          const response = res.data
          self.loading = false;
          if (response.success === 1) {
            localStorage.setItem('LoggedUser', JSON.stringify(response.userData))
            localStorage.setItem('Token', JSON.stringify(response.token))
            self.login();
          } else {                  
            self.otpErrors = [`OTP does not match the one sent you have ${self.retries} retries left`];
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        
      }else if(this.retries <= 0){
        this.showOTP = false
      }

    },
  },
  created(){
    this.checkConenction();
  },
  
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">
.myspinner {
  position: fixed;
  top: 40%;
  left: 22%;
  z-index: 999;
}

@media (max-width: 767px) {
  .myspinner {
    position: fixed;
    top: 38%;
    left: 40%;
    z-index: 999;
  }
}
</style>
